import {
  useGetAllTemplateCampaignQuery,
  useGetTemplateCampaignQuery,
} from '../api/templates-api';
import {skipToken} from '@reduxjs/toolkit/query';

export const useTemplateCampaignQuery = (roles: any, args: any) => {
  const isAdmin = roles?.includes('admin');

  const allQuery = useGetAllTemplateCampaignQuery(isAdmin ? args : skipToken);
  const userQuery = useGetTemplateCampaignQuery(!isAdmin ? args : skipToken);

  return isAdmin ? allQuery : userQuery;
};
